import { MapPin, Clock3, ShieldCheck, HeartHandshake } from "lucide-react";

export const TrustStrip = ({ locale }) => {
  const labels = { en: ["Local bouquet preparation", "Available delivery dates", "Secure payment in EUR", "Fleurinelle order support"], fr: ["Bouquets préparés localement", "Dates de livraison disponibles", "Paiement sécurisé en EUR", "Service client Fleurinelle"], es: ["Ramos preparados localmente", "Fechas de entrega disponibles", "Pago seguro en EUR", "Atención de Fleurinelle"], ar: ["تحضير الباقات محلياً", "مواعيد توصيل متاحة", "دفع آمن باليورو", "دعم طلبات فلورينيل"], it: ["Preparazione locale del bouquet", "Date di consegna disponibili", "Pagamento sicuro in EUR", "Assistenza ordini Fleurinelle"], nl: ["Lokale boeketbereiding", "Beschikbare bezorgdata", "Veilig betalen in EUR", "Fleurinelle orderondersteuning"], de: ["Lokale Strauß-Anfertigung", "Verfügbare Lieferdaten", "Sichere Zahlung in EUR", "Fleurinelle Bestellsupport"] }[locale];
  const items = [MapPin, Clock3, ShieldCheck, HeartHandshake].map((Icon, i) => [Icon, labels[i]]);
  return (
    <section data-testid="trust-strip" className="border-y border-brass-light bg-plaster-deep">
      <div className="max-w-content mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-brass-light">
        {items.map(([Icon, label], i) => (
          <div key={label} data-testid={`trust-fact-${i}`} className="flex items-center gap-3 py-6 lg:px-8 first:lg:ps-0">
            <Icon size={20} className="text-brass shrink-0" />
            <span className="text-sm text-charcoal">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustStrip;
